import { useMemo } from 'react';
import { useGetPortalScopeQuery } from '@/store/api/authApi';
import { useGetRequirenteScopeQuery, useListRequirentesQuery } from '@/store/api/requirentesApi';
import { resolveRequirenteHome } from '@/features/requirentes/resolveRequirenteHome';

export function useRequirentePortal() {
  const { data: portalScope } = useGetPortalScopeQuery();
  const { data: requirenteScope } = useGetRequirenteScopeQuery();
  const { data: requirentesList } = useListRequirentesQuery();

  return useMemo(() => {
    const mode = requirenteScope?.mode
      ?? portalScope?.requirentePortal.mode
      ?? 'none';
    const primaryContextId = requirenteScope?.primaryContextId
      ?? portalScope?.requirentePortal.primaryContextId
      ?? null;
    const isRequirenteOnly = mode === 'requirente';
    const isAdminCatalog = mode === 'admin';
    const requirenteHomePath = resolveRequirenteHome({ mode, primaryContextId });
    /** @deprecated use requirenteHomePath */
    const portalPath = requirenteHomePath;

    return {
      mode,
      primaryContextId,
      isRequirenteOnly,
      isAdminCatalog,
      requirenteHomePath,
      portalPath,
      requirentes: requirentesList?.items ?? [],
    };
  }, [portalScope, requirenteScope, requirentesList]);
}
